<template>
    <div class="audio-player-container" :style="`width: ${audioSize.width}; height: ${audioSize.height};`">
        <audio class="audio-player" controls>
            <source v-if="isBase64==true" :src="`data:audio/wav;base64,${audio.base64Value}`">
            <source v-else :src="audioUrl">
            Your browser does not support the audio element.
        </audio>
    </div>
</template>

<script>
export default {
    props: {
        audio: {
            type: Object,
        },
        audioUrl: {
            type: String,
        },
        isBase64: {
            type: Boolean,
            default: false
        },
        audioSize: {
            type: Object,
            default: function () {
                return {
                    width: "220px",
                    height: "auto"
                };
            },
        }
    }
};
</script>

<style scoped>
.audio-player-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.audio-player {
    width: 100%;
    height: 54px;
}
</style>


// WEBPACK FOOTER //
// src/components/AudioPlayer/index.vue